(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Utilities
//
// ------------------------------------

(function ($) {

    if (typeof window.Util == 'undefined') window.Util = {};

    Util = {

        // ------------------------------------
        // Util Init
        // ------------------------------------

        init: function () {

            // console.log('Util::init()');

        },

        // ------------------------------------
        // Check if element exists
        // ------------------------------------

        exists: function (item) {

            return ($(item).length > 0 ? true : false);

        },

        // ------------------------------------
        // CSS Helpers
        // ------------------------------------

        detectBrowser: function () {

            // Browser Isn't available anymore
            // console.log($.browser,"HERE")
            // Firefox
            // if ($.browser.mozilla) { $('html').addClass('firefox'); }
            //
            // // Chrome
            // if ($.browser.chrome) { $('html').addClass('chrome'); }
            //
            // // Safari
            // if ($.browser.safari) { $('html').addClass('safari'); }
            //
            // // IE
            // if ($.browser.msie) { $('html').addClass('ie'); }
            if (!!navigator.userAgent.match(/Trident\/7\./)) { $('html').addClass('ie'); }

            // OS
            var os = window.navigator.platform.toLowerCase();

            // Windows
            if (os.indexOf('win') >= 0) { $('html').addClass('windows'); }
            else if (os.indexOf('mac') >= 0) { $('html').addClass('mac'); }

            // IOS
            if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) { $('html').addClass('ios'); }

            // IE Version
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                var version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                $('html').addClass('ie' + version);

            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                var version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                $('html').addClass('ie' + version);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                var version = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                $('html').addClass('ie' + version);
            }

        },

        // ------------------------------------
        // Get Querystring
        // ------------------------------------

        querystring: function () {

            var vars = [], hash;
            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;

        },

        // ------------------------------------
        // Set Cookie
        // ------------------------------------

        setCookie: function (c_name, value, exdays) {
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + exdays);
            var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString() + "; path=/");
            document.cookie = c_name + "=" + c_value;
        },

        // ------------------------------------
        // Get Cookie
        // ------------------------------------

        getCookie: function (c_name) {
            var i, x, y, ARRcookies = document.cookie.split(";");
            for (i = 0; i < ARRcookies.length; i++) {
                x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
                y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
                x = x.replace(/^\s+|\s+$/g, "");
                if (x == c_name) {
                    return unescape(y);
                }
            }
        }

    };

    module.exports = Util;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/utils.js","/modules")